import { ModalIds, type Modal, type ModalActionPayload } from '@/components/ModalManager/types';
import { type ActionContext } from 'vuex';

export enum ToastTheme {
  Danger = 'danger',
  Success = 'success',
  Warning = 'warning',
  Info = 'info',
}
export interface Toast {
  isOpen: boolean;
  title: string;
  theme: ToastTheme;
  message: string;
}

export interface AppState {
  toast: Toast;
  modals: Modal[];
}

const getters = {
  getToast(state: AppState): Toast {
    return state.toast;
  },
  getModals(state: AppState): Modal[] {
    return state.modals;
  },
};

const mutations = {
  setToast(state: AppState, toast: Toast): void {
    state.toast = { ...toast };
  },
  setModals(state: AppState, modals: Modal[]): void {
    state.modals = [...modals];
  },
};

const actions = {
  showToast(context: ActionContext<AppState, any>, toast: Toast): void {
    toast.isOpen = true;
    context.commit('setToast', toast);
  },
  hideToast(context: ActionContext<AppState, any>): void {
    context.commit('setToast', {});
  },
  openModal(context: ActionContext<AppState, any>, modalActionPayload: ModalActionPayload): void {
    const modals = context.getters.getModals as Modal[];
    const isOpen = true;
    context.commit(
      'setModals',
      modals.map((modal) =>
        modal.id === modalActionPayload.id
          ? { ...modal, isOpen, options: modalActionPayload.options }
          : modal,
      ),
    );
  },
  closeModal(context: ActionContext<AppState, any>, modalActionPayload: ModalActionPayload): void {
    const modals = context.getters.getModals as Modal[];
    const isOpen = false;

    context.commit(
      'setModals',
      modals.map((modal) =>
        modal.id === modalActionPayload.id ? { ...modal, isOpen, options: undefined } : modal,
      ),
    );
  },
};

const _default = {
  state: {
    toast: {},
    modals: [
      {
        id: ModalIds.AgencySwitcherModal,
        isOpen: false,
      },
      {
        id: ModalIds.NoActiveAgencyModal,
        isOpen: false,
      },
      {
        id: ModalIds.MfaConfirmationModal,
        isOpen: false,
      },
      {
        id: ModalIds.GotMandateModal,
        isOpen: false,
      },
      {
        id: ModalIds.NotGotMandateModal,
        isOpen: false,
      },
      {
        id: ModalIds.NotSoldModal,
        isOpen: false,
      },
      {
        id: ModalIds.PropertySoldModal,
        isOpen: false,
      },
      {
        id: ModalIds.ExportCsvModal,
        isOpen: false,
      },
      {
        id: ModalIds.BulkPromotionModal,
        isOpen: false,
      },
      {
        id: ModalIds.ResetMfaModal,
        isOpen: false,
      },
    ],
  },
  getters,
  mutations,
  actions,
};
export default _default;
